import { render, staticRenderFns } from "./EditAssignTeamToProject.vue?vue&type=template&id=5a96e87e&scoped=true"
import script from "./EditAssignTeamToProject.vue?vue&type=script&lang=js"
export * from "./EditAssignTeamToProject.vue?vue&type=script&lang=js"
import style0 from "./EditAssignTeamToProject.vue?vue&type=style&index=0&id=5a96e87e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a96e87e",
  null
  
)

export default component.exports